import { Component, OnInit } from '@angular/core';
import { DefaultLangChangeEvent, LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { environment } from '@pg-env/environment';
import { Spinkit } from 'ng-http-loader';
import { AppInsightsService } from '@markpieszak/ng-application-insights';
import { Gtag } from 'angular-gtag';
import { IdleService } from '@nttp/common-service/idle.service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FundAccountService } from '@pg-app/client/client-dashboard/components/fund-account/service/fund-account.service';
import { KeepAliveService } from '@nttp/common-service/keepalive.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'np-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = environment.brandName;
  public spinkit = Spinkit;

  constructor(
    public translate: TranslateService,
    private appInsightsService: AppInsightsService,
    gtag: Gtag,
    idleService: IdleService,
    authService: AuthService,
    router: Router,
    private fundAccountService: FundAccountService,
    keepAliveService: KeepAliveService,
    titleService: Title
  ) {
    translate.setDefaultLang(environment.defaultLanguage);

    translate.use(environment.defaultLanguage);

    translate.onLangChange.subscribe((event: LangChangeEvent) => { });

    translate.onTranslationChange.subscribe((event: TranslationChangeEvent) => { });

    translate.onDefaultLangChange.subscribe((event: DefaultLangChangeEvent) => { });
    appInsightsService.config = {
      instrumentationKey: environment.appInsights.instrumentationKey
    };
    // then make sure to initialize and start-up app insights
    appInsightsService.init();
    keepAliveService.start(environment.timeFreshtokenSec);

    router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      if (authService.accessToken && router.url.indexOf('/auth/') === -1) {
        if (!idleService.isServiceRunning()) {
          idleService.startIdleSvc();
        }

        if (!keepAliveService.isServiceRunning()) {
          keepAliveService.startService();
        }

      } else {
        if (idleService.isServiceRunning()) {
          idleService.stopIdleSvc();
        }

        if (keepAliveService.isServiceRunning()) {
          keepAliveService.stopService();
        }
      }
    });

    router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(e => {
      if (sessionStorage.getItem('clickBuyNow') === 'false' && sessionStorage.getItem('clickGetRate') === 'true') {
        this.fundAccountService.sendEmailQuoteAlerts(JSON.parse(sessionStorage.getItem('newTrade'))).subscribe();
        sessionStorage.removeItem('clickGetRate');
        sessionStorage.removeItem('clickBuyNow');
      }
    });

    titleService.setTitle(this.title);
  }

  ngOnInit() {
    window.addEventListener('beforeunload', function (e) {
      if (sessionStorage.getItem('clickBuyNow') === 'false' && sessionStorage.getItem('clickGetRate') === 'true') {
        const xhr = new XMLHttpRequest();
        xhr.open('POST',
          `${environment.customerApiUrl}/trade/send-quote-alerts`, false);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(sessionStorage.getItem('newTrade'));
      }
    });
  }
}
